export default __webpack_public_path__ + "media/zurb/img/playground/lord-kelvin-quote-b209793016dc63cadfb389fb8cb05730.png";